import { setSubmissionErrors, useNotify } from 'react-admin';
import { FieldValues, UseFormSetError } from 'react-hook-form';

/**
 * save() de Create/Edit em modo pessimistic devolve o body.errors do 400 e, nesse caso, o
 * react-admin não mostra toast: espera o submit padrão do form fazer isso. Botão que chama
 * save() por fora do submit padrão precisa marcar os campos e avisar por conta própria.
 */
export const applySaveErrors = (
  errors: FieldValues | void | undefined,
  setError: UseFormSetError<FieldValues>,
  notify: ReturnType<typeof useNotify>,
) => {
  if (errors == null) return;
  setSubmissionErrors(errors, setError);
  notify(errors['root.serverError'] ?? 'ra.message.invalid_form', { type: 'error' });
};
